import React from "react"
import {CustomPageWrapper, introduce, introduce_title, introduce_desc} from './style.jsx'
import {isApplyCustomLayout,isCustomLayoutBgLight} from '../const.js'
import localeService from '../../../service/localeService'

const CustomPage = ({children, pathname = ''}) => {
  return <CustomPageWrapper pathname={pathname} isApplyCustomLayout={isApplyCustomLayout} isCustomLayoutBgLight={isCustomLayoutBgLight} >
      <div className={introduce}>
        <h2 className={introduce_title}>
          {localeService.getTranslate(`LOGIN_PAGE_TITLE_${APP_CONFIG.channelId}`)}
        </h2>
        <p className={introduce_desc}>
          {localeService.getTranslate(`LOGIN_PAGE_DESC_${APP_CONFIG.channelId}`)}
        </p>
      </div>
    {children}
  </CustomPageWrapper>
}
export default CustomPage



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomPageWrapper/index.js